module.exports = __webpack_public_path__ + "img/4baca70.jpg";